import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import keyBinder from 'shared/lib/keyBinder';
import CuesheetCursorActions from 'flux/actions/cuesheet/CuesheetCursorActions';
import CuesheetCellActions from 'flux/actions/cuesheet/CuesheetCellActions';
import ResizingTextareaStore from 'flux/stores/cuesheet/ResizingTextareaStore';
import ResizingTextareaActions from 'flux/actions/cuesheet/ResizingTextareaActions';
import CuesheetTransientCellStore from 'flux/stores/cuesheet/CuesheetTransientCellStore';
import CuesheetTransientCellActions from 'flux/actions/cuesheet/CuesheetTransientCellActions';
import {
  KeyScopes,
  DefaultEditableCellTextAreaHeight,
} from 'flux/stores/cuesheet/CuesheetConstants';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import isElementInViewport from 'shared/lib/isElementInViewport';

const bindings = [
  ['tab', '_handleTabKeyPress'],
  ['shift+tab', '_handleLeftShiftTabPress'],
];

/**
 * A text area that resizes to adjust for the text content size
 *
 *
 */
export default React.createClass({
  displayName: 'ResizingTextarea',

  mixins: [
    Reflux.connectFilter(ResizingTextareaStore, 'textareaHeight', (st) =>
      st.get('height'),
    ),
    Reflux.connect(CuesheetTransientCellStore, 'transientText'),
    PureRenderMixin,
  ],

  propTypes: {
    onTextChanged: React.PropTypes.func.isRequired,
    children: React.PropTypes.string.isRequired,
    resize: React.PropTypes.bool,
    styles: React.PropTypes.object,
  },

  getInitialState() {
    /*
    We add hasFocus so that onBlur and componentWillUnmount won't both call _handleBlur.
    We need componentWillUmount to handle situations where a user scrolls the text area
    out of the viewport and onBlur is no longer callable
    */
    return {
      hasFocus: false,
    };
  },

  getDefaultProps() {
    return {
      resize: true,
      styles: {},
      defaultHeight: DefaultEditableCellTextAreaHeight,
    };
  },

  render() {
    const { transientText, textareaHeight } = this.state;

    const { defaultHeight } = this.props;

    let textAreaStyle = Object.assign(
        {
          width: '100%',
          position: 'absolute',
          resize: 'none',
        },
        this.props.styles,
      ),
      /**
       * Order of precedence for text area value:
       *
       * 1. First use any transient value (connected to CuesheetTransientCellStore)
       * 2. Then use the child value
       * 3. Finally use an empty string
       */
      text =
        typeof transientText === 'string'
          ? transientText
          : this.props.children || '';
    textAreaStyle.height = textareaHeight || defaultHeight;

    let wrapperStyle = {
      height: '100%',
    };

    return (
      <div
        onKeyDown={(e) => {
          //Prevent save when hitting ESC key
          if (e.keyCode === 27) this._saveOnUnmount = false;
        }}
        ref="wrapper"
        style={wrapperStyle}
      >
        <textarea
          ref={(input) => {
            if (!input) return;
            this.textAreaInput = input;
          }}
          className="cs-cell-textarea"
          style={textAreaStyle}
          defaultValue={text}
          onChange={this._handleTextareaChange}
          onBlur={this._handleBlur}
          onKeyPress={this._handleKeyPress}
        />
      </div>
    );
  },

  _handleKeyPress(e) {
    /**
     * If the element is outside the viewport, attempt to bring it back...this will not work if the textarea has
     * been unmounted due to FDT buffering
     */
    if (!isElementInViewport(e.target) && !this.props.allowEditingOffViewport) {
      e.preventDefault();
      CuesheetCellActions.refocusCell();
      return;
    }
  },

  _handleTextareaChange(e) {
    CuesheetTransientCellActions.setTransientCellValue(e.target.value);
  },

  componentDidMount() {
    this._focus();
    this._setupResizing();
    this._bindHotKeys();

    /**
     * Determine wether or not to save heightAndText when component unmounts.
     */
    this._saveOnUnmount = true;
  },

  componentWillUnmount() {
    this._tearDownResizing();
    this._unbindHotKeys();

    if (this._saveOnUnmount) this._handleBlur();
  },

  _focus() {
    this.setState({
      hasFocus: true,
    });
    const textAreaNode = this._getTextareaDOMNode(),
      text = textAreaNode.value;
    textAreaNode.focus();
    textAreaNode.value = '';
    textAreaNode.value = text;
  },

  _setupResizing() {
    if (!this.props.resize) return;

    this._getTextareaDOMNode().addEventListener('keyup', this._resize);

    this._resize(0);
  },

  _tearDownResizing() {
    if (!this.props.resize) return;

    this._getTextareaDOMNode().removeEventListener('keyup', this._resize);
  },

  _handleBlur() {
    const state = this.state;

    if (!state.hasFocus) return;

    this.setState({
      hasFocus: false,
    });

    const update = {
      text: this._getTextareaDOMNode().value,
    };

    if (state.textareaHeight) update.height = state.height;

    /**
     * Clear transient cell data here...in some cases when a text change event
     * was fired right as a blur occurred (roughly the same time), the component
     * would unmount and remount to fire the event, then unmount again.
     *
     * Related to issue #1893
     */
    CuesheetTransientCellActions.clearTransientCellValue();

    this.props.onTextChanged(update);
    ResizingTextareaActions.clearHeight();
  },

  _getTextareaDOMNode() {
    return ReactDOM.findDOMNode(this.textAreaInput);
  },

  /**
   *
   * Resize the textAreaNode based on the contents...
   *
   * @param buffer resize pixel buffer
   *
   */
  _resize(buffer) {
    var textAreaNode = this._getTextareaDOMNode(),
      wrapper = ReactDOM.findDOMNode(this.refs.wrapper),
      cellHeight = wrapper.offsetHeight,
      resizeHeightState = textAreaNode.scrollHeight;

    buffer = typeof buffer === 'number' ? buffer : 0;

    //Resize to the highest value, either the size of the text area or the cell height
    ResizingTextareaActions.setHeight(
      Math.max(resizeHeightState + buffer, cellHeight),
    );
  },

  _bindHotKeys() {
    bindings.forEach((binding) => {
      let [key, handler] = binding;
      keyBinder.assign(key, KeyScopes.CellEditing, this[handler]);
    });
  },

  _unbindHotKeys() {
    bindings.forEach((binding) => {
      let [key, handler] = binding;
      keyBinder.unbind(key, KeyScopes.CellEditing, this[handler]);
    });
  },

  _handleTabKeyPress(e) {
    e.preventDefault();

    CuesheetCursorActions.moveCursorRight();
    this._handleBlur();
  },

  _handleLeftShiftTabPress(e) {
    e.preventDefault();

    CuesheetCursorActions.moveCursorLeft();
    this._handleBlur();
  },
});
